import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ClipboardList, Users, Shield } from 'lucide-react';

// Import the content from TrackingPage, RecipientsPage, and CredentialRequestsPage
import TrackingPageContent from './TrackingPage';
import RecipientsPageContent from './RecipientsPage';
import CredentialRequestsPageContent from './CredentialRequestsPage';

export default function DocumentsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('view') || 'tracking';
  const highlightLatest = searchParams.get('highlight') === 'latest';

  const handleTabChange = (value) => {
    // Preserve existing query params (e.g. `?status=sent` set by the
    // dashboard stat cards) instead of overwriting them.
    const next = new URLSearchParams(searchParams);
    next.set('view', value);
    setSearchParams(next, { replace: true });
  };

  return (
    <DashboardLayout>
      <div className="space-y-6" data-testid="documents-page">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-heading text-3xl font-bold text-foreground">Documents</h1>
            <p className="text-muted-foreground font-body mt-1">
              Track and manage all sent documents
            </p>
          </div>
        </div>

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="w-fit">
            <TabsTrigger value="tracking" className="flex items-center gap-2" data-testid="tab-tracking">
              <ClipboardList className="w-4 h-4" />
              All Documents
            </TabsTrigger>
            <TabsTrigger value="recipients" className="flex items-center gap-2" data-testid="tab-recipients">
              <Users className="w-4 h-4" />
              By Recipient
            </TabsTrigger>
            <TabsTrigger value="credentials" className="flex items-center gap-2" data-testid="tab-credentials">
              <Shield className="w-4 h-4" />
              Credential Requests
            </TabsTrigger>
          </TabsList>

          <div className="mt-6">
            <TabsContent value="tracking" className="mt-0">
              <TrackingPageContent embedded={true} highlightLatest={highlightLatest} />
            </TabsContent>

            <TabsContent value="recipients" className="mt-0">
              <RecipientsPageContent embedded={true} />
            </TabsContent>

            <TabsContent value="credentials" className="mt-0">
              <CredentialRequestsPageContent embedded={true} />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
